import React ,{Fragment}from 'react'
import { useSnackbar } from 'notistack';
import {IconButton} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
 const CustomSnackBar = ({other}) => {
    const { closeSnackbar } = useSnackbar();
    const handleClose = sKey=>  sKey? closeSnackbar(sKey):closeSnackbar();
    
    
    return (
        <Fragment>
        <IconButton aria-label="dismiss" onClick={()=> handleClose(other) }>
        {/* <IconButton aria-label="dismiss" onClick={()=> closeSnackbar() }> */}
             <CloseIcon />
               </IconButton>
        </Fragment>
    )
}

export  const snackAction = (key) => <CustomSnackBar other={key}/>
export default CustomSnackBar;